import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';
import {
  ParkingDailyStatsResponse,
  ParkingDailyStatsParams
} from '../../resources/types/statisticsTypes';

export const statisticsApi = createApi({
  reducerPath: 'statisticsApi',
  baseQuery,
  endpoints: builder => ({
    getParkingDailyStats: builder.query<ParkingDailyStatsResponse, ParkingDailyStatsParams>({
      query: params => ({
        url: '/statistics/parking_daily_stats',
        params
      })
    })
  })
});

export const {
  useGetParkingDailyStatsQuery,
  useLazyGetParkingDailyStatsQuery
} = statisticsApi;
